<template>
  <span>
    <!-- VERIFICA SE EXISTE MINHA PERSONALIZAÇÃO --> 
    <template v-if='Object.keys(tabCampo).length >= 1'>
      <div style="display: inline-block; margin: 0px 6px 0px 2px;" :id='cpntId + "-mper"'>
        <RF-Button 
          :cpntId='cpntId + "bt-mPer"'
          :cpntStatus='""' 
          :cpntIcone='"fa fa-cog"'
          :cpntClass='[ "btn", "btn-default" ]'

          @onClickButton='mPerMostrar = !mPerMostrar'
          :data-time='cpntTime'
        ></RF-Button>
      </div>

      <!-- CRIA O CONTEUDO DA MINHA PERSONALIZAÇÃO -->
      <transition name="slide-fade">
        <div style='z-index: 600;' :id='cpntId + "-mper-conteudo"' class="rf-conteudo-mPer" v-show='mPerMostrar'>
          <div class="rf-tooltip-triangle"></div>

          <!-- TITULO MINHA PERSONALIZAÇÃO -->
          <div class="rf-mPer-Titulo">
            Minha Personalização
            <RF-Button 
              :cpntId='cpntId + "bt-mPer-salvar"'
              :cpntStatus='""' 
              :cpntTexto='"Salvar"'
              :cpntClass='[ "btn", "btn-default" ]'

              @onClickButton='putSalvarMPer'
              :data-time='cpntTime'
            ></RF-Button>
          </div>

          <!-- SELETOR NUMERO DE REGISTRO POR PAGINA -->
          <div v-if="tabCampo.hasOwnProperty('mPerRpp')">
            <span class='rf-tipo-normal'>
              Apresentar
            </span>
            <div style="vertical-align: middle; height: 34px; width: 55px; display: inline-block; margin: 0px 2px 0px 2px;">
              <RF-Select2 style="vertical-align: middle;"
                :class='"class-time-" + time + " rf-field-tamanho-" + tabCampo.mPerRpp.tamanho'
                :cpntStatus='tabCampo.mPerRpp.status'
                :cpntId='tabCampo.mPerRpp.id'
                :cpntClassDivField='tabCampo.mPerRpp.classDivField'
                :cpntClassSelect='tabCampo.mPerRpp.classSelect2'
                :cpntNome='tabCampo.mPerRpp.nome'
                :cpntValue='tabCampo.mPerRpp.value'
                :cpntOptions='tabCampo.mPerRpp.options'
                :cpntKeyValue='tabCampo.mPerRpp.keyValue'
                :cpntKeyMostra='tabCampo.mPerRpp.keyMostra'
                :cpntAutoComplete='tabCampo.mPerRpp.autocomplete'
                :cpntDisabled='tabCampo.mPerRpp.disabled'
                :cpntMostrar='tabCampo.mPerRpp.mostrar'
                :cpntMensagem='tabCampo.mPerRpp.mensagem'
                :cpntOptionInicialNome='tabCampo.mPerRpp.optionInicialNome'
                :cpntOptionInicialValue='tabCampo.mPerRpp.optionInicialValue'
                :cpntMensagemTipo='tabCampo.mPerRpp.mensagemTipo'
                :cpntAddOption='tabCampo.mPerRpp.addOption'
                :cpntMultiple='tabCampo.mPerRpp.multiple'
                :cpntExplica='tabCampo.mPerRpp.explica'

                :cpntOnChange='tabCampo.mPerRpp.onChange'
              ></RF-Select2>
            </div>

            <span class='rf-tipo-normal'>
              registros por página
            </span>
            <hr/>
          </div>

          <!-- SELETOR OS TIPOS DE ORDEM -->
          <div v-if="tabCampo.hasOwnProperty('mPerOrder')" style="margin-top: -10px;">
            <span class='rf-tipo-normal'>
              Ordenando por:
            </span>
            <div style="vertical-align: middle; height: 34px; width: 170px; display: inline-block; margin: 0px 2px 0px 2px;">
              <RF-Select2 style="vertical-align: middle;"
                :class='"class-time-" + time + " rf-field-tamanho-" + tabCampo.mPerOrder.tamanho'
                :cpntStatus='tabCampo.mPerOrder.status'
                :cpntId='tabCampo.mPerOrder.id'
                :cpntClassDivField='tabCampo.mPerOrder.classDivField'
                :cpntClassSelect='tabCampo.mPerOrder.classSelect2'
                :cpntNome='tabCampo.mPerOrder.nome'
                :cpntValue='tabCampo.mPerOrder.value'
                :cpntOptions='tabCampo.mPerOrder.options'
                :cpntKeyValue='tabCampo.mPerOrder.keyValue'
                :cpntKeyMostra='tabCampo.mPerOrder.keyMostra'
                :cpntAutoComplete='tabCampo.mPerOrder.autocomplete'
                :cpntDisabled='tabCampo.mPerOrder.disabled'
                :cpntMostrar='tabCampo.mPerOrder.mostrar'
                :cpntMensagem='tabCampo.mPerOrder.mensagem'
                :cpntOptionInicialNome='tabCampo.mPerOrder.optionInicialNome'
                :cpntOptionInicialValue='tabCampo.mPerOrder.optionInicialValue'
                :cpntMensagemTipo='tabCampo.mPerOrder.mensagemTipo'
                :cpntAddOption='tabCampo.mPerOrder.addOption'
                :cpntMultiple='tabCampo.mPerOrder.multiple'
                :cpntExplica='tabCampo.mPerOrder.explica'

                :cpntOnChange='tabCampo.mPerOrder.onChange'
              ></RF-Select2>
            </div>
            <hr/>
          </div>

          <div v-if="tabCampo.hasOwnProperty('mPerField')" style="margin-top: -10px;">
            <span class='rf-tipo-normal'>Com os campos selecionados abaixo:</span><br/><br/>

            <template v-for="(ckeckbox, index) in tabCampo.mPerField">
              <div :key="index" style="display: inline-block; width: 145px; text-align: left;">
                <RF-Checkbox-Tabela
                  :cpntStatus='""'
                  :cpntId='cpntId + "--mPerField--" + ckeckbox.chave' 
                  :cpntNome='" " + ckeckbox.nome + (ckeckbox.mper === 2 ? " (Padrão)" : "")'
                  :cpntValue='ckeckbox.chave'
                  :cpntChecked='tabCampo.mPerFieldSelected'
                  :cpntDisabled='ckeckbox.mper === 2'

                  :cpntOnChange='onChangeMper'
                  :data-time='cpntTime'
                ></RF-Checkbox-Tabela>
              </div>
            </template>
          </div>

        </div>
      </transition>
    </template>
  </span>
</template>

<style scoped>
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .rf-conteudo-mPer {
    font-size: var(--font-base-soma-11);
    background-color: #f4f9fe;
    text-decoration: none;
    border-top: 1px solid #d5dee5;
    border-bottom: 1px solid #d5dee5;
  }

  .rf-conteudo-mPer {
    -moz-user-select: none;
   -khtml-user-select: none;
   -webkit-user-select: none;

    min-height: 50px;
    max-width: 335px;
    min-width: 335px;
    margin-top: 10px;
    color: var(--color-base-02);
    position: absolute;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: rgba(0,0,0,0.1) 0 2px 4px;

    font-weight: normal;
    z-index: 600;
  }
    .rf-conteudo-mPer > div {
      padding: 10px 20px;
    }
    .rf-conteudo-mPer > div:nth-child(3) {
      padding: 10px 20px 0px 20px;
    }
    .rf-conteudo-mPer > div:last-child {
      padding: 10px 20px 10px 20px;
    }
    .rf-conteudo-mPer > .rf-tooltip-triangle {
      -moz-transition: .3s;
      -ms-transition: .3s;
      -o-transition: .3s;
      transition: .3s;
      border-style: solid;
      width: 0px;
      height: 0px;
      line-height: 0px;

      border-color: transparent transparent #f7f7f7;
      border-width: 0px 9px 15px;

      padding: 0px;
      position: absolute;
      top: -15px;
      left: 10px;
    }

    .rf-conteudo-mPer > .rf-mPer-Titulo {
      padding: 8px 14px;
      margin: 0;
      font-size: var(--font-base-soma-14);
      font-weight: 400;
      line-height: 18px;
      background-color: #f7f7f7;
      border-bottom: 1px solid #ebebeb;
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
      text-align: center;

      padding-top: 5px;
    }
    .rf-conteudo-mPer hr {
      margin-top: 10px;
      margin-bottom: 10px;
    }
</style>

<script>
  export default {
    props: {
      cpntTime: {
        required: true,
        type: [ String, Number ]
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-mper-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntPagina: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntMper: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntOnRefreshTabela: {
        required: true
      }
    },
    components: {
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
    },
    data: function () {
      return {
        tabCampo: {},
        mPerMostrar: false,
      }
    },
    mounted: function () {
      this.criarPersonalizacao()
    },
    methods: {
      criarPersonalizacao: function () {
      var self = this

        // LIMPA TODOS OS CAMPOS EXISTENTES
        self.tabCampo = {}

        if (Object.keys(self.cpntMper).length >= 1) {
          var createCampos = {}

          if (self.cpntMper.rpp !== false) {
            createCampos.mPerRpp = {
              tipo: 'select2',
              tamanho: 61,
              keyValue: 'value',
              keyMostra: [ 'value' ],
              value: self.cpntMper.rpp.toString(),
              valueIni: self.cpntMper.rpp.toString(),
              options: [ { value: '5' }, { value: '10' }, { value: '15' }, { value: '20' }, { value: '25' }, { value: '30' }, { value: '35' }, { value: '40' }, { value: '45' }, { value: '50' }, { value: '55' }, { value: '60' }, { value: '65' }, { value: '70' }, { value: '75' }, { value: '80' }, { value: '85' }, { value: '90' }, { value: '95' }, { value: '100' } ],
              optionInicialNome: '',
              onChange: function (value) {
                self.tabCampo.mPerRpp.value = value
              }
            }
          }

          if (self.cpntMper.order !== false) {
            if (!self.cpntMper.hasOwnProperty('orderOptions')) {
              self.cpntMper.orderOptions = [
                { value: '0', nome: 'Última Alteração' },
                { value: '1', nome: 'Código Crescente' },
                { value: '2', nome: 'Ordem Alfabética' },
                { value: '3', nome: 'Código Decrescente' }
              ]
            }

            createCampos.mPerOrder = {
              tipo: 'select2',
              tamanho: 57,
              keyValue: 'value',
              keyMostra: [ 'nome' ],
              value: self.cpntMper.order.toString(),
              valueIni: self.cpntMper.order.toString(),
              options: self.cpntMper.orderOptions.filter(item => self.cpntMper.orderField.hasOwnProperty(item.value)),
              optionInicialNome: '',
              onChange: function (value) {
                self.tabCampo.mPerOrder.value = value
              }
            }
          }

          self.$store.state.FUN_CREATE_KEY_FIELDS(createCampos, function (fields) {
            // ADICIONA TODOS OS ID AOS CAMPOS
            for (var key1 in fields) {
              fields[key1].id = self.cpntId + '-' + key1
            }

            // SETA OS CAMPOS RECEBIDOS
            self.tabCampo = fields

            if (self.cpntMper.field !== false) {
              self.tabCampo.mPerField = []
              self.tabCampo.mPerFieldSelected = []

              if (self.cpntMper.field.length >= 1) {
                self.tabCampo.mPerField = self.cpntMper.field
                for (var key in self.cpntMper.field) {
                  if (self.cpntMper.field[key].mper >= 1) {
                    self.tabCampo.mPerFieldSelected.push(self.cpntMper.field[key].chave)
                  }
                }
              }
            }

            // CALCULA A PAGINAÇÃO
            self.calculaPaginacao()
          })
        } else {
          // CALCULA A PAGINAÇÃO
          self.calculaPaginacao()
        }
      },
      onChangeMper: function (checked, id) {
        var index = id.split('--')  // 0 = NOME | 1 = CAMPO | 2 = VALOR

        switch (checked) {
          case true:
            this.tabCampo.mPerFieldSelected.push(index[2])
            break

          case false:
            this.tabCampo.mPerFieldSelected = this.tabCampo.mPerFieldSelected.filter(item => item !== index[2])
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      putSalvarMPer: function () {
        var self = this

        // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { model: '', rpp: '', order: '', ac: '', field: '[]' }

        // SETA O ID DA TABELA
        formData['model'] = self.cpntMper.model

        // SETA A QUANTIDADE DE REGISTRO POR PAGINA
        if (self.cpntMper.rpp !== false) {
          formData['rpp'] = self.tabCampo.mPerRpp.value
        }

        // SETA O TIPO DE ORDENAÇÃO NA PAGINA
        if (self.cpntMper.order !== false) {
          formData['order'] = self.tabCampo.mPerOrder.value
        }

        // SETA SE UTILIZA O AUTOCOMPLITE NESTA PAGINA
        if (self.cpntMper.hasOwnProperty('ac')) {
          // eslint-disable-next-line
          console.error('WEB [409]: Item "ac" da minha personalização não implementado na tabela ainda.')
          // formData['ac'] = self.mPer['order']['value']
        }

        // SETA AS COLUNAS QUE DEVE APRESENTAR NA TABELA
        if (self.cpntMper.field !== false) {
          formData['field'] = []

          for (var keyMper in self.tabCampo.mPerField) {
            if (self.tabCampo.mPerField[keyMper].hasOwnProperty('mper') && self.tabCampo.mPerField[keyMper].mper <= 1) {
              if (self.tabCampo.mPerFieldSelected.indexOf(self.tabCampo.mPerField[keyMper].chave) !== -1) {
                formData['field'].push(self.tabCampo.mPerField[keyMper].chave)
              }
            }
          }

          formData['field'] = formData['field'].join()
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI('/config/mper', 'PUT', formData, function (apiSuccess) {
          // FECHA A MINHA PERSONALIZAÇÃO
          self.mPerMostrar = false

          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // REMOVE MINHA PERSONALIZAÇÃO SALVA
            self.$store.commit('REMOVE_MINHA_PERSONALIZACAO', self.cpntMper.model)

            // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
            self.cpntOnRefreshTabela()
          })
        }, function (apiError) {
          // SETA O STATUS RECEBIDO
          self.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      calculaPaginacao: function () {
        var self = this

        if (Object.keys(self.cpntPagina).length >= 1) {
          var createCampos = {
            pagSel: {
              tipo: 'select2',
              tamanho: 61,
              keyValue: 'value',
              keyMostra: [ 'value' ],
              value: self.cpntPagina.num.toString(),
              options: [],
              optionInicialNome: '',
              onChange: function (value) {
                // SETA O VALOR NO SELETOR
                self.tabCampo.pagSel.value = value

                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                self.cpntOnRefreshTabela(Number(value), self.tabCampo.pagRpp.value)
              }
            },
            pagRpp: {
              tipo: 'select2',
              tamanho: 61,
              keyValue: 'value',
              keyMostra: [ 'value' ],
              value: self.cpntPagina.rpp.toString(),
              options: self.tabCampo.mPerRpp.options,
              optionInicialNome: '',
              onChange: function (value) {
                // SETA O VALOR NO SELETOR
                self.tabCampo.pagRpp.value = value

                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                self.cpntOnRefreshTabela(1, Number(value))
              }
            }
          }

          if (isNaN(self.cpntCountAll) === false && Number(self.cpntCountAll) === 0) {
            self.regIni = 0
            self.regFim = 0
            self.qPag = 1
          } else if (isNaN(self.cpntCountAll) === false && Number(self.cpntCountAll) >= 1) {
            var pagArray = []

            if (Number(self.cpntPagina.num) === 1) {
              self.regIni = 1
            } else {
              self.regIni = ((Number(self.cpntPagina.num) * Number(self.cpntPagina.rpp)) - Number(self.cpntPagina.rpp))
            }

            if (self.regIni === 0) {
              self.regIni = 1
            }

            self.qPag = Math.ceil((Number(self.cpntCountAll)) / (Number(self.cpntPagina.rpp)))

            if (Number(self.cpntPagina.num) === 1 && Number(self.cpntPagina.rpp) <= Number(self.cpntCountAll)) {
              self.regFim = Number(self.cpntPagina.rpp)
            } else if (Number(self.cpntPagina.num) === self.qPag) {
              self.regFim = Number(self.cpntCountAll)
            } else if (Number(self.cpntPagina.num) === self.qPag && Number(self.cpntPagina.rpp) <= Number(self.cpntCountAll)) {
              self.regFim = (Number(self.cpntCountAll) - Number(self.cpntPagina.rpp)) + Number(Number(self.cpntPagina.rpp))
            } else {
              self.regFim = (Number(self.cpntPagina.num) * Number(self.cpntPagina.rpp))
            }

            for (var p = 1; p <= self.qPag; p++) {
              pagArray.push({ value: p })
            }

            createCampos.pagSel.options = pagArray
          }

          if (Object.keys(createCampos).length >= 1) {
            self.$store.state.FUN_CREATE_KEY_FIELDS(createCampos, function (fields) {
              // ADICIONA TODOS OS ID AOS CAMPOS
              for (var key1 in fields) {
                fields[key1].id = self.cpntId + '-' + key1
              }

              // SETA OS CAMPOS RECEBIDOS
              self.tabCampo = Object.assign(self.tabCampo, fields)

              // SETA O STATUS
              self.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              setTimeout(function () {
                self.blockEvento = false
                // self.criarQtip()

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }, 1000)
            })
          } else {
            self.status = { loc: 'WEB', cod: 9999, err: 'Erro ao calcular quantidade de pagina.' }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        } else {
          // SETA O STATUS
          self.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            self.blockEvento = false
            // self.criarQtip()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 1000)
        }
      }
    }
  }
</script>
